import React, { Component } from 'react';
import { LanguageConsumer } from '../lib/LanguageContext'
import { Link } from  'react-router-dom'
import Footer from '../Footer'
import './Error.css';

class Error extends Component {

    render() {
        return (
         <LanguageConsumer>
            {({polyglot}) =>
            (<div className='Error'>
                <div className='ErrorBody'>
                    <div className='ErrorHeader'>
                        <h1>{polyglot.t('fetchErrorMessage')}</h1>
                    </div>
                    <div className='ErrorSubtitle'>
                        <h3>{polyglot.t('fetchErrorSubtitle')}</h3>
                    </div>
                    <div className='ErrorLink'>
                        <Link to='/'>{polyglot.t('fetchErrorLink')}</Link>
                    </div>
                </div>
                <Footer/>
            </div>)}
         </LanguageConsumer>
        )
    }
}


export default Error;



// WEBPACK FOOTER //
// ./src/components/Error.js